import { EDeductionType } from "./EDeductionType";
import { ReadonlySet } from "../data-structures/ReadonlySet";

const NON_UNIQUE_DEDUCTION_TYPES = new ReadonlySet([
  EDeductionType.GARNISHMENT,
  EDeductionType.MISCELLANEOUS,
  EDeductionType.SECTION_125,
  EDeductionType.EMPLOYER_SPONSORED_HEALTH_COVERAGE,
]);

export const UNIQUE_DEDUCTION_TYPES = new ReadonlySet(
  Object.values(EDeductionType).filter(
    (type) => !NON_UNIQUE_DEDUCTION_TYPES.has(type as any)
  )
);
